<!-- 需求-搜索 -->
<template>
	<div class="wrap">

		<div class="header-wrap">
			<div class="header">
				<img src="../assets/return.png" class="return-img">
				<p class="header-title">搜索</p>
			</div>
			<div class="search-box">
				<div class="search-bar">
					<img src="../assets/search-icon.png" class="search-icon">
					<input type="search" value="" placeholder="请输入关键字进行搜索" class="search-input" disabled />
				</div>
			</div>
			<ul class="sub-tab-list">
				<li>默认排序</li>
				<li class="active">
					时间
					<img src="../assets/icon-6.png" class="tab-icon">
				</li>
			</ul>
		</div>

		<ul class="list">
			<li  @click="$router.push('/demand-details')">
				<img src="../assets/img.png" class="img">
				<div class="item-sidebar">
					<p class="item-name">AUTOSAR 工程师AUTOSAR工…</p>
					<p class="item-row">
						<img src="../assets/img.png">
						搞一下汽车电子
					</p>
					<p class="pay-num">
						<img src="../assets/play.png">
						3218
					</p>
				</div>
			</li>
			<!-- 暂无数据展示 -->
			<div class="normal-box-small">
				<img src="../assets/normal.png">
				暂无数据
			</div>
		</ul>


		<div class="float-box">
			<button type="button" @click="$router.push('/feedback')">没找到？点我反馈</button>
		</div>



	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {

				status: 0
			};
		},
		mounted() {},
		methods: {},
	}
</script>

<style scoped>
	/* 头部样式 */
	.header-wrap {
		width: 100%;
		height: 118px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 500;
		background-color: #FFFFFF;
	}

	.header-wrap-tab-list-none {
		height: 80px;
		padding-bottom: 10px;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #FFFFFF;
		z-index: 999;
		padding: 0 15px;
		position: relative;
		box-sizing: border-box;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.search-box {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.search-bar {
		flex: 1;
		height: 36px;
		background-color: #F3F3F3;
		border-radius: 100px;
		display: flex;
		align-items: center;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.search-icon {
		width: 14px;
		margin-right: 8px;
	}

	.search-input {
		flex: 1;
		font-size: 14px;
	}

	.search-input::placeholder {
		color: #7F7F7F;
	}

	.tab-list>li {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 38px;
		line-height: 38px;
		font-size: 16px;
		color: #555555;
		position: relative;
	}

	.tab-list>li.active {
		font-size: 18px;
		font-weight: 500;
		color: #222222;
	}

	.tab-list>li.active::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		width: 18px;
		height: 4px;
	}


	.sub-tab-list {
		width: 100%;
		height: 38px;
		display: flex;
		align-items: center;
	}

	.sub-tab-list>li {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 38px;
		line-height: 38px;
		font-size: 14px;
		color: #555555;
		position: relative;
	}

	.sub-tab-list>li.active {
		font-weight: 500;
		color: #222222;
	}

	.sub-tab-list>li.active::after {
		content: "";
		width: 18px;
		height: 4px;
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
	}

	.tab-icon {
		width: 6px;
		margin-left: 2px;
	}

	.wrap {
		width: 100%;
		height: calc(100vh - 118px);
		display: flex;
		flex-direction: row;
		margin: 118px 0 0;
		box-sizing: border-box;
		background-color: #F4F4F4;
		overflow-y: auto;
	}

	.wrap-tab-list-none {
		height: calc(100vh - 90px);
		margin: 90px 0 0;
	}


	.sub-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 12px 15px;
		box-sizing: border-box;
		/*height: 100%;*/
		overflow: auto;
	}

	.sub-list>li {
		width: 100%;
		display: flex;
		align-items: center;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
		margin-bottom: 12px;
		padding: 10px;
		box-sizing: border-box;
		position: relative;
	}


	.sub-list>li:last-child {
		margin-bottom: 0;
	}

	.float-box {
		position: fixed;
		left: 50%;
		transform: translate(-50%, 0);
		bottom: 40px;
		z-index: 499;
	}

	.float-box>button {
		min-width: 175px;
		height: 44px;
		line-height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #2A63F3;
		border-radius: 100px;
		color: #FFFFFF;
		font-size: 18px;
		font-weight: 500;
	}

	.window {
		width: 100%;
		display: flex;
		flex-direction: column;
		/*position: fixed;*/
		/*bottom: 0;*/
		/*left: 0;*/
		z-index: 99999999;
		background-color: #FFFFFF;
		border-radius: 16px 16px 0 0;
	}

	.window-top {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 35px 25px;
		box-sizing: border-box;
	}

	.window-btn {
		width: 100%;
		display: flex;
		align-items: center;
		color: #222222;
		font-size: 16px;
		margin-bottom: 30px;
	}

	.window-btn:last-child {
		margin-bottom: 0;
	}

	.window-btn.del {
		color: #FF1010;
	}

	.window-btn>img {
		width: 24px;
		margin-right: 16px;
	}

	.window-btn2>img {
		height: 38px;
		margin-bottom: 5px;
	}

	.window-btn-box {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 15px 38px;
		box-sizing: border-box;
	}

	.window-btn-box>button {
		width: 100%;
		height: 40px;
		line-height: 40px;
		background-color: #F3F3F3;
		border-radius: 100px;
		color: #222222;
		font-size: 16px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.window-btn-box2>button {
		color: #999999;
		font-size: 16px;
	}

	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 12px 15px;
		box-sizing: border-box;
	}

	.list>li {
		width: 100%;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
		margin-bottom: 12px;
		padding: 10px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
	}

	.img {
		width: 86px;
		height: 86px;
		border-radius: 10px;
		margin-right: 14px;
		object-fit: cover;
	}

	.item-sidebar {
		flex: 1;
		height: 76px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.item-name {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #222222;
		font-size: 15px;
	}

	.item-row {
		width: 100%;
		display: flex;
		align-items: center;
		color: #999999;
		font-size: 12px;
	}

	.item-row>img {
		width: 18px;
		height: 18px;
		border-radius: 50%;
		margin-right: 4px;
	}

	.pay-num {
		display: flex;
		align-items: center;
		font-size: 12px;
		color: #999999;
	}

	.pay-num>img {
		width: 12px;
		margin-right: 4px;
	}

	.normal-box-small {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 14px;
		color: #999992;
		padding: 120px 0;
	}

	.normal-box-small>img {
		width: 150px;
		margin-bottom: 9px;
	}
</style>
